// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_features_select-center_select-center_module_ts":"cdb501f9ba8a187f","src_app_features_sessions_sessions_module_ts":"a854f8017d5d78cd"}[chunkId] + ".js";
};